import {ServiceMessageType} from "../../Content/PeerActivity/types";
import {ActionsType} from "../../types";

export interface MainFileType{
  uuid?: string;
  url: string;
  fileName?: string;
  fileSize?: number;
  formattedSize?: string;
  downLoadUrl?: string;
  dateTime? : string;
  contentType?: string;
  sort?: number;
  enabled?: boolean;
  width?:number;
  height?:number;
  serviceMessages?: Array<ServiceMessageType>;
  actions?: ActionsType
  /** Picked from a media source (Google Drive) and not arrived yet, or failed to. */
  importStatus?: MainFileImportStatus;
  importError?: string;
}

export enum MainFileImportStatus {
  PENDING = "pending",
  FAILED = "failed",
}

export enum MainFileImageTypes {
  JPG = "jpg",
  JPEG = "jpeg",
  PNG = "png",
  GIF = "gif",
}

export enum MainFileVideoTypes {
  MP4 = "mp4",
  AVI = "avi",
  MOV = "mov",
}
